import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Legge la scadenza dal payload del JWT (claim `exp`, in secondi) senza
// bisogno del secret. Ritorna true se il token manca, è malformato o è scaduto,
// così l'app può reindirizzare al login. Margine di 5s per evitare race sul confine.
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(part));
    return !payload.exp || payload.exp * 1000 <= Date.now() + 5000;
  } catch {
    return true; // token non decodificabile → trattalo come non valido
  }
}

export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      username: null,
      role: null,
      login:  (token, username, role = null) => set({ token, username, role }),
      logout: () => set({ token: null, username: null, role: null }),
    }),
    { name: 'jarvis-auth' }
  )
);
